import React, { ReactNode } from 'react';
import { Grid, Paper, styled } from '@mui/material';

const classesPrefix = 'pagePaper';

const classes = {
    paper: `${classesPrefix}-paper`,
};

const StyledGrid = styled(Grid)(({ theme }) => {
    return {
        [`&.${classes.paper}`]: {
            margin: theme.spacing(2),
            borderRadius: 0,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            overflow: 'auto',
            '@media (max-height: 660px)': {
                overflow: 'visible',
            },
            [theme.breakpoints.down('sm')]: {
                overflow: 'visible',
            },
        },
    };
}) as typeof Grid;

const PagePaper = ({
    children,
}: {
    children?: ReactNode;
}): React.JSX.Element => {
    return (
        <StyledGrid item xs className={classes.paper} component={Paper}>
            {children}
        </StyledGrid>
    );
};

export default PagePaper;
